import {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {Col, Container, Modal, Row} from 'react-bootstrap';
import {connect, useSelector} from 'react-redux'
import {reduxStore} from '../../../../services/redux/ReduxIndex'
import {setBasketList, setRightBasketModal,} from '../../../../services/redux/actions/BasketAction'
import BasketInfo from './BasketInfo'
import BasketList from './BasketList'
import Api from "../../../../services/Api";
import UserInfo from "../../../auth/UserInfo";
import HelperGeneral from "../../../../helpers/HelperGeneral";

const RightBasketModal = () => {
    const {basketList, rightBasketModal} = reduxStore.getState().BasketReducer;
    const currentBasketList = useSelector(state => state.BasketReducer.basketList);
    const [show, setShow] = useState(false);
    const [totalPoint, setTotalPoint] = useState(0);

    const handleClose = () => {
        setShow(false);
        setRightBasketModal(false);
    }

    const getBasketTotalPoint = (basketList) => {
        //Toplam sepet puanı
        let totalPoint = 0;
        if (basketList?.products?.length > 0) {
            totalPoint = basketList?.products?.reduce((sum, value) => {
                return sum + parseInt(value?.quantity) * parseInt(value?.gift_point);
            }, 0)

            setTotalPoint(totalPoint);
        }
    }

    useEffect(() => {
        setShow(rightBasketModal);
        setRightBasketModal(rightBasketModal);
        getBasketTotalPoint(currentBasketList);
    }, [rightBasketModal])

    useEffect(() => {
        getBasketTotalPoint(currentBasketList);
    }, [currentBasketList])

    return (
        <Modal className={'right-modal'} show={show} onHide={handleClose} scrollable={true}>
            <Modal.Header closeButton>
                <Modal.Title>Alışveriş Sepeti <span>({currentBasketList?.products ? currentBasketList?.products?.length : 0} ürün)</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BasketList handleClose={handleClose} setTotalPoint={setTotalPoint}/>
            </Modal.Body>
            <Modal.Footer className={'d-block'}>
                <Container className={'p-0'}>
                    <Row>
                        {
                            currentBasketList?.products?.length > 0 && (
                                <>
                                    <Col xs={8} className={'d-flex align-items-center justify-content-start'}>
                                        Toplam Harcanacak Puan
                                    </Col>
                                    <Col xs={4} className={'d-flex align-items-center justify-content-end'}>
                                        {totalPoint} puan
                                    </Col>
                                    <Col xs={12} className={'d-flex align-items-center justify-content-center text-center'}>
                                        <a
                                            href="/sepetim"
                                            onClick={e => {
                                                if (currentBasketList?.warningArray?.length > 0) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            className={`btn btn-primary-2 confirm-gift-btn mt-3 mb-3 w-100 ${currentBasketList?.warningArray?.length > 0 ? 'disabled' : ''}`}
                                        >
                                            Hediyeni Onayla
                                        </a>
                                    </Col>
                                </>
                            )
                        }
                        <Col xs={12} className={'d-flex align-items-center mt-2 justify-content-center text-center'}>
                            <a onClick={handleClose} className={'continue-shop-text text-body'}>
                                Hediye Seçimine Devam Et
                            </a>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    )
}

const mapStateToProps = (state, ownProps) => ({
    rightBasketModal: state.BasketReducer.rightBasketModal,
    basketList: state.BasketReducer.basketList,
})

export default withRouter(connect(mapStateToProps)(RightBasketModal))


